/* Coordinator jobs search filters reducer */
import * as _ from 'lodash';

import * as Actions from '../actions';
import { DateRanges } from '../common/dateranges';

export interface ISearchFiltersCoordinatorJobsState {
    coordinator: string;
    fromDate: string;
    paid: number;
    regionId: number;
    statusId: number;
    toDate: string;
}

const defaultFromDateValue = DateRanges.DateRangeOptionValues.LAST_TWELVE_MONTHS;
const initialState: ISearchFiltersCoordinatorJobsState = {
    coordinator: '',
    fromDate: DateRanges.getStartDate(defaultFromDateValue), // moment().subtract(12, 'months').format(AppConfiguration.getMomentShortDateFormat()),
    paid: 0,
    regionId: -1,
    statusId: -1,
    toDate: '',
};

export function searchFiltersCoordinatorJobsReducer(state: ISearchFiltersCoordinatorJobsState = initialState, action: any): ISearchFiltersCoordinatorJobsState {
    switch (action.type) {
        case Actions.SEARCH_COORDINATOR_JOBS_COORDINATOR:
            return _.merge({}, state, { coordinator: action.username });
        case Actions.SEARCH_COORDINATOR_JOBS_FROM_DATE:
            return _.merge({}, state, { fromDate: action.fromDate });
        case Actions.SEARCH_COORDINATOR_JOBS_PAID:
            return _.merge({}, state, { paid: action.paid });
        case Actions.SEARCH_COORDINATOR_JOBS_REGION:
            return _.merge({}, state, { regionId: action.regionId });
        case Actions.SEARCH_COORDINATOR_JOBS_STATUS:
            return _.merge({}, state, { statusId: action.statusId });
        case Actions.SEARCH_COORDINATOR_JOBS_TO_DATE:
            return _.merge({}, state, { toDate: action.toDate });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersCoordinatorJobsReducer.tsx